import { destroyTokens } from '@/plugins/push-notification'

window.onSubmitLogin = function() {
    document.querySelector('form').submit();
}

destroyTokens()
